import type { TViewMode } from '../profileDetailUserDataSubAccounts';
import { useQueryParams } from '@/hooks';
import type { TTabname } from '..';
import {DataTablePageSizeEnum, SortEnum } from '@/enums';
import { useEffect, useMemo } from 'react';

type TName = 'tab' | 'view';

const useUrlParams = () => {
	const defaults = useMemo(() => ({
		limit: DataTablePageSizeEnum._10,
		page: 1,
		sortBy: 'createdAt',
		sortType: SortEnum.DESC,
	}), []);

	const {
		values: [tab, view, limit, page, sortBy, sortType],
		setValue,
		setValues,
		updateSearchParams
	} = useQueryParams(['tab', 'view', 'limit', 'page', 'sortBy', 'sortType'], {
		view: 'detailed' as TViewMode,
		tab: 'photos' as TTabname,
		...defaults
	});

	// Write missing defaults to URL on mount, but only transaction params when on the transactions tab
	// biome-ignore lint/correctness/useExhaustiveDependencies: run once on mount only
	useEffect(() => {
		updateSearchParams(l => {
			if ((l.get('tab') ?? 'photos') === 'transactions') {
				Object.entries(defaults).forEach(([key, val]) => {
					if (!l.has(key)) l.set(key, String(val));
				});
			}
			return l;
		});
	}, []);

	return {
		setValue: (name: TName, value: any) => setValue(name, value),
		view: view as TViewMode,
		tab: tab as TTabname,
		limit,
		page,
		sortBy,
		sortType,
		setValues
	};
};

export default useUrlParams;
